export default "__VITE_ASSET__bK9y3AI___"